import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    const rootElement = document.getElementById('root')
    if (rootElement) {
      rootElement.scrollTo({ top: 0, behavior: 'instant' })
      rootElement.scrollTop = 0
    }

    window.scrollTo({ top: 0, behavior: 'instant' })
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
  }, [pathname])

  return null
}
